import { useTranslation } from "react-i18next";

type CareerLevelBadgeProps = {
  level?: number;
  width?: number;
  height?: number;
  showTitle?: boolean;
};

const CareerLevelBadge = ({
  level,
  width = 86,
  height = 92,
  showTitle = true,
}: CareerLevelBadgeProps) => {
  const { t } = useTranslation();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 86 92"
      fill="none"
    >
      <g filter="url(#filter0_i_17951_2167)">
        <path
          d="M32.487 3.98337C38.857 -0.247975 47.143 -0.247978 53.513 3.98337L75.412 18.5301C80.3625 21.8185 83.489 27.2339 83.8617 33.1653L85.51 59.4038C85.9894 67.0361 81.8465 74.2119 74.997 77.6128L51.4497 89.3046C46.1266 91.9476 39.8734 91.9476 34.5503 89.3046L11.003 77.6128C4.15354 74.2119 0.010567 67.0361 0.490028 59.4038L2.13834 33.1653C2.51096 27.2339 5.63754 21.8185 10.588 18.5301L32.487 3.98337Z"
          fill="#242366"
        />
      </g>
      <path
        d="M33.5938 5.64941C39.2932 1.86348 46.7068 1.86348 52.4062 5.64941L74.3057 20.1963C78.7348 23.1386 81.5318 27.9841 81.8652 33.291L83.5137 59.5293C83.9426 66.3581 80.2359 72.7784 74.1074 75.8213L50.5605 87.5137C45.7978 89.8785 40.2022 89.8785 35.4395 87.5137L11.8926 75.8213C5.76414 72.7784 2.05736 66.3581 2.48633 59.5293L4.13477 33.291C4.46815 27.9841 7.26515 23.1386 11.6943 20.1963L33.5938 5.64941Z"
        stroke="url(#paint0_linear_17951_2167)"
        strokeWidth="4"
      />
      {showTitle && (
        <text
          x="43"
          y="38"
          textAnchor="middle"
          fill="#F2F2F2"
          fontSize="12"
          fontWeight="400"
          fontFamily="Cabin"
        >
          {t("components.MenuLateral.estagio")}
        </text>
      )}
      <text
        x="43"
        y="64"
        textAnchor="middle"
        fill="#F2F2F2"
        fontSize={showTitle ? "24" : "36"}
        fontWeight="700"
        fontFamily="Cabin"
      >
        {level}
      </text>
      <defs>
        <filter
          id="filter0_i_17951_2167"
          x="0.452393"
          y="0.810547"
          width="85.0952"
          height="94.4766"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="13.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0597531 0 0 0 0 0.0574266 0 0 0 0 0.173756 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_17951_2167"
          />
        </filter>
        <linearGradient
          id="paint0_linear_17951_2167"
          x1="43"
          y1="-3"
          x2="43"
          y2="97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B3DE" />
          <stop offset="1" stopColor="#4846CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CareerLevelBadge;
